import { SettingsBox } from './settings-box/settings-box.model';
import { CalcBox } from './calc-box/calc-box.model';
import { ResultBox, CashFlowData } from './result-box/result-box.model';


export class BondData {
  constructor(
    public settingsBox: SettingsBox,

    public resultBox: ResultBox,

    public subheaderBox: Subheader,

    public calcBox: CalcBox

  ) { }
}


export class Subheader {
  constructor(
    public ticker: string,

    public isin: string,

    public wpk: string,

    public netchangePercent: number,

    public netchangeValue: number,

    public lastPrice: number,

    public exchangeName: string,

    public lastPriceTimestamp: Date
  ) { }
}

export class DataArgs {
  constructor(
    public valueDate: Date,

    public expectedYield: number,

    public taxRate: number,

    public nominalVolume: number,

    public dayCountConvention: string,

    public calculationMethod: string,
  ) { }
}

export class CalculateArgsWithId {
  constructor(

    public firstCouponDate: string,

    public interestRate: number,

    public maturityDate: string,

    public redemptionPrice: number,

    public valueDate: string,

    public issueDate: string,

    public lastCouponDate: string,

    public cleanPrice: number,

    public expectedYield: number,

    public taxRate: number,

    public nominalVolume: number,

    public couponFrequency: number,

    public dayCountConvention: string,

    public calculationMethod: string,

    public instrumentId: number,

  ) { }
}

export class CalculateArgsWithoutId {
  constructor(
    public firstCouponDate: string,

    public interestRate: number,

    public maturityDate: string,

    public redemptionPrice: number,

    public valueDate: string,

    public issueDate: string,

    public lastCouponDate: string,

    public cleanPrice: number,

    public expectedYield: number,

    public taxRate: number,

    public nominalVolume: number,

    public couponFrequency: number,

    public dayCountConvention: string,

    public calculationMethod: string,

    public instrumentId?: number,

  ) { }
}

export class CalculatedResult {
  constructor(
    public dirtyPrice: number,

    public cleanPrice: number,

    public modifiedDuration: number,

    public expectedYield: number,

    public duration: number,

    public errorMessage: string,

    public errorCode: string,

    public grossYield: number,

    public netYield: number,

    public accruedInterest: number,

    public basisPointValue: number,

    public convexity: number,

    public maturity: number,

    public accruedInterestDays: number,

    public cashflowItem: CashFlowData[],

  ) { }
}

export class CouponDate {
  constructor(
    public couponDate: string
  ) { }
}








